// extracted by mini-css-extract-plugin
export var icon = "_5k-1";
export var subtext = "_5k-0";